import React, { useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { BsDownload, BsTrash } from "react-icons/bs";
import { CgClipboard } from "react-icons/cg";
import { FaArrowRight, FaRegEdit } from "react-icons/fa";

export const BestSellers = () => {
  const [showOrderPage, setShowOrderPage] = useState(false);
  const [order, setOrder] = useState(null);

  const ordersData = [
    {
      product: "Savory Food UI Kit",
      productCat: "Mobile UI Kit",
      productsImg:
        "https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=800",
      date: "Sept. 7, 2023",
      sales: "120",
      gross: "3000",
      net: "2800",
      price: "$16",
      status: "Needs Revisions",
    },
    {
      product: "Savory Food UI Kit",
      productCat: "Mobile UI Kit",
      productsImg:
        "https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=800",
      date: "Sept. 7, 2023",
      sales: "120",
      gross: "3000",
      net: "2800",
      price: "$16",
      status: "Draft",
    },
    {
      product: "Savory Food UI Kit",
      productCat: "Mobile UI Kit",
      productsImg:
        "https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=800",
      date: "Sept. 7, 2023",
      sales: "120",
      gross: "3000",
      net: "2800",
      price: "$16",
      status: "Active",
    },
    {
      product: "Savory Food UI Kit",
      productCat: "Mobile UI Kit",
      productsImg:
        "https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=800",
      date: "Sept. 7, 2023",
      sales: "120",
      gross: "3000",
      net: "2800",
      price: "$16",
      status: "Needs Revisions",
    },
  ];

  return (
    <div className="bg-[#f0f0f0] my-4 rounded-lg px-4 py-3  dark:bg-[#282828]">
      <div className="flex justify-between items-center">
        <h1 className="font-medium text-2xl">Best Sellers</h1>
        <div className="flex items-center space-x-2 border-[2px] border-[#D3D3D3] rounded-lg px-4 py-[10px]">
          <p>All Products</p>
          <FaArrowRight />
        </div>
      </div>

      <div className="relative my-4 hidescroll border-[#F0F0F0] border-[2px] px-2  dark:border-[#3d3d3d] overflow-x-auto md:min-w-[800px] rounded-lg py-2">
        <table className="w-full text-sm text-left rtl:text-right">
          <thead className="text-xs  text-gray-700 uppercase dark:text-white dark:bg-[#2F2F2F] ">
            <tr>
              <th scope="col" className="px-6 py-3">
                PRODUCT
              </th>
              <th scope="col" className="px-6 py-3">
                Price
              </th>
              <th scope="col" className="px-6 py-3">
                SALES
              </th>
              <th scope="col" className="px-6 py-3">
                GROSS
              </th>
              <th scope="col" className="px-6 py-3">
                NET PROFIT
              </th>
            </tr>
          </thead>
          <tbody>
            {ordersData.map((order, index) => (
              <tr
                key={index}
                className={
                  index === 0 || index !== ordersData.length - 1
                    ? " border-[#F0F0F0] border-b   dark:border-[#3D3D3D] dark:bg-transparent"
                    : ""
                }
              >
                <td
                  onClick={() => {
                    setShowOrderPage(true);
                    setOrder(order);
                  }}
                  className="px-6 cursor-pointer py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap"
                >
                  <div className="flex space-x-2 items-center">
                    <img
                      className="w-14 rounded-lg"
                      src={order.productsImg}
                      alt=""
                    />

                    <div>
                      <p className="font-semibold">{order.product}</p>
                      <p className="opacity-60">{order.productCat}</p>
                    </div>
                  </div>
                </td>

                <td className="px-6 py-4">{order.price}</td>
                <td className="px-6 py-4">{order.sales}</td>
                <td className="px-6 py-4">${order.gross}</td>
                <td className="px-6 py-4">${order.net}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
